var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBombTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1964 9.48215L41.625 15.0536L44.4643 17.8929C45.4714 18.9 45.4714 20.5286 44.4643 21.525L42.6 23.3893C43.8643 26.1857 44.5714 29.2929 44.5714 32.5607C44.5714 44.8715 34.5964 54.8464 22.2857 54.8464C9.975 54.8464 0 44.8822 0 32.5714C0 20.2608 9.975 10.2857 22.2857 10.2857C25.5536 10.2857 28.6607 10.9929 31.4571 12.2571L33.3214 10.3929C34.3286 9.38574 35.9571 9.38574 36.9536 10.3929L39.7929 13.2321L45.3643 7.66071L47.1964 9.48215ZM53.5714 6.42857H51C50.2929 6.42857 49.7143 7.00718 49.7143 7.71429C49.7143 8.42144 50.2929 9 51 9H53.5714C54.2786 9 54.8571 8.42144 54.8571 7.71429C54.8571 7.00718 54.2786 6.42857 53.5714 6.42857ZM47.1429 0C46.4357 0 45.8571 0.578606 45.8571 1.28571V3.85714C45.8571 4.5643 46.4357 5.14286 47.1429 5.14286C47.85 5.14286 48.4286 4.5643 48.4286 3.85714V1.28571C48.4286 0.578606 47.85 0 47.1429 0ZM50.775 5.89289L52.5964 4.07145C53.1 3.56786 53.1 2.7536 52.5964 2.25001C52.0929 1.74642 51.2786 1.74642 50.775 2.25001L48.9536 4.07145C48.45 4.57499 48.45 5.3893 48.9536 5.89289C49.4679 6.39643 50.2821 6.39643 50.775 5.89289ZM43.5107 5.89289C44.0143 6.39643 44.8286 6.39643 45.3321 5.89289C45.8357 5.3893 45.8357 4.57499 45.3321 4.07145L43.5107 2.25001C43.0071 1.74642 42.1929 1.74642 41.6893 2.25001C41.1857 2.7536 41.1857 3.56786 41.6893 4.07145L43.5107 5.89289ZM50.775 9.53573C50.2714 9.03214 49.4571 9.03214 48.9536 9.53573C48.45 10.0393 48.45 10.8536 48.9536 11.3572L50.775 13.1786C51.2786 13.6821 52.0929 13.6821 52.5964 13.1786C53.1 12.675 53.1 11.8607 52.5964 11.3572L50.775 9.53573Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17C32.2463 17 40 24.2414 40 33C40 41.7586 32.2463 49 22.5 49C12.7537 49 5 41.7586 5 33C5 24.2414 12.7537 17 22.5 17Z",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 22,
    width: 5.14793,
    height: 13.7278,
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 35.9472,
    width: 5.14793,
    height: 11.4236,
    transform: "rotate(-45.1764 19 35.9472)",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombTimer);
export default __webpack_public_path__ + "static/media/bomb-timer.4becb0813ef96fa3d0cc2f26aebb8ba9.svg";
export { ForwardRef as ReactComponent };